import { Box, Dialog, DialogContent, useTheme } from '@mui/material';
import React from 'react';
import { Descope } from '@descope/react-sdk';
import { ITheme } from 'types/theme';

interface ICompanySettingsSSODialogProps {
	currentCompany: string;
	onSuccess: () => void;
	onError: (e: string | Event) => void;
	onCancel: () => void;
}

const CompanySettingsSSODialog = ({
	currentCompany,
	onSuccess,
	onError,
	onCancel
}: ICompanySettingsSSODialogProps) => {
	const theme = useTheme<ITheme>();
	return (
		<Dialog
			open
			maxWidth="sm"
			disableRestoreFocus
			onClose={onCancel}
			PaperProps={{ sx: { minHeight: 200, maxWidth: 700 } }}
			data-testid="sso-setup-dialog"
		>
			<DialogContent sx={{ p: 0 }}>
				<Box data-testid="sso-setup-container">
					<Descope
						flowId="saml-config"
						onSuccess={onSuccess}
						tenant={currentCompany}
						onError={onError}
						theme={theme.palette.mode}
					/>
				</Box>
			</DialogContent>
		</Dialog>
	);
};

export default CompanySettingsSSODialog;
